import { render, staticRenderFns } from "./TabSpr.vue?vue&type=template&id=072d2382"
import script from "./js/tabSpr.js?vue&type=script&lang=js&external"
export * from "./js/tabSpr.js?vue&type=script&lang=js&external"
import style0 from "./TabSpr.vue?vue&type=style&index=0&id=072d2382&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports